import {combineReducers, createStore} from "redux";
import LoginReducer from "./reducers/LoginReducer";

//La store se encarga de almacenar la información en forma de objeto y pasarsela a la interfaz o vista.

const appReducer = combineReducers(
    [{
        LoginReducer,
    }]
);

export default createStore(LoginReducer);



